import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2a766d39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl text-primary font-bold mb-4 text-center" }, "Sıkça Sorulan Sorular", -1))
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-lg font-medium" }
const _hoisted_6 = { class: "text-xl" }
const _hoisted_7 = {
  key: 0,
  class: "p-4 text-gray-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "py-3"
        }, [
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.toggleFaq(item.id)),
            class: "w-full text-left flex justify-between items-center py-2 px-4 bg-gray-100 hover:bg-gray-200 rounded-lg"
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.question), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.isOpen ? '−' : '+'), 1)
          ], 8, _hoisted_4),
          (item.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.answer), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}